import filter from 'lodash-es/filter';
import find from 'lodash-es/find';
import { Subject, Subscription } from 'rxjs';
import { RequestService } from '@df/api/request/request.service';
import { Customer } from '@df/session/api/customer';
import { Injectable } from '@angular/core';
import { Address, IAddressData } from '@df/session/api/address-book/address';

@Injectable({
    providedIn: 'root'
})
export class AddressBook {
    addresses: Address[] = [];
    private _shippingAddresses: Address[] | undefined;

    protected addressBookUpdateSubject = new Subject<this>();

    constructor(private customer: Customer, protected requestService: RequestService) {
        this.register();
    }

    private register() {
        this.customer.register(
            {
                id: 'addressBook',
                listener: 'addresses',
                account: true
            },
            this
        );
    }

    /**
     * Register observer
     * Observer function are called on basket update
     * @param  {() => void} callback
     */
    subscribe(...args): Subscription {
        return this.addressBookUpdateSubject.subscribe(...args);
    }

    byId(id: number): Address | undefined {
        return find(this.addresses, { id });
    }

    create(data: IAddressData) {
        return new Address(data);
    }

    setData(data: IAddressData[]) {
        this.addresses = data ? data.map(item => this.create(item)) : [];
        this._shippingAddresses = undefined;
        this.addressBookUpdateSubject.next(this);
    }

    /**
     * Its buffered like this cause when we set data we may not have countries loaded yet
     */
    get shippingAddresses(): Address[] {
        if (!this._shippingAddresses) {
            this._shippingAddresses = this.addresses.filter(item => !item.getCountry()?.noShipping);
        }
        return this._shippingAddresses;
    }

    get data(): IAddressData[] {
        return this.addresses.map(i => i.data);
    }

    get billing(): Address | undefined {
        return find(this.addresses, { is_billing: true });
    }

    get shipping(): Address | undefined {
        return find(this.addresses, { is_shipping: true });
    }

    get differentDefaults(): boolean {
        return !find(this.addresses, { is_billing: true, is_shipping: true });
    }

    get additional(): Address[] {
        return filter(this.addresses, function (item) {
            return !item.is_billing && !item.is_shipping;
        });
    }

    get hasAddresses(): boolean {
        return this.addresses && this.addresses.length ? true : false;
    }
}

/**
 * Register service in customer
 */
declare module '@df/session/api/customer' {
    interface Customer {
        addressBook: AddressBook;
    }
}
